import { Grid, Paper, makeStyles, Typography, Button } from "@material-ui/core"
import {getRandomInt} from '../function/common'

/**
 * Styleの定義
 */
 const useStyles = makeStyles((theme) => ({
    grid: {
        height: '100%',
    },
    button: {
        '&:disabled': {
            backgroundColor: '#FFAA00',
            fontWeight: 'bold',
            color: '#FFFFFF',
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            width: '90%'
        },
    }
}));

const CleaningCounter = (props) => {
    // Styleの読み込み
    const classes = useStyles();
    var counter = 10
    const emoIcon = [
        "(^｡^)",
        "(￣∀￣)",
        "(*´∇｀*)",
        "(*^◯^*)",
        "Σ（ﾟдﾟlll）",
    ]
    var randomInt = getRandomInt(0, 5)
    return (
        <Grid className={classes.grid} style={{height: '100%'}}>
            <Button variant="outlined" className={classes.button} disabled>
                ↓掃除ガチャ生活
                <br/>
                通算{props.counter}日目！
                <br/>
                {emoIcon[randomInt]}
            </Button>
        </Grid>
    )
}

export default CleaningCounter;